import { primitives } from '@veneer/primitives';
import styled from 'styled-components';

const { color, typography, layout } = primitives;
const { highContrastGray, gray9 } = color;
const { size2: fontSize2, lineHeight3 } = typography;
const { size2, size4, size1, size5, breakpoint1 } = layout;
export interface CardWithDisableProps {
  $disabled?: boolean;
}

export const Container = styled.article<CardWithDisableProps>`
  top: -${size2};
  left: -${size2};
  background: #f8f8f8;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  ${({ $disabled }) =>
    $disabled
      ? `
      pointer-events: none;
      color: ${highContrastGray} !important;

      * {
        color: ${highContrastGray} !important;
      }
    `
      : null}
`;

export const TextBlock = styled.div`
  && {
    font-size: ${fontSize2};
    line-height: ${lineHeight3};
    text-align: center;
    padding: 0 ${size4};
    color: ${gray9};
  }

  &&:first-child {
    margin-top: ${size1};
  }

  && + * {
    margin-top: ${size5};
  }
`;

export const Backface = styled.div`
  width: 100%;
  height: 200px;

  @media screen and (min-width: ${breakpoint1}px) {
    height: 300px;
  }
`;
